<template>
  <!-- 暂无权限 -->
  <the-no-authority v-if="!authority"></the-no-authority>
  <div class="page_box" v-else>
      <div class="page_option_box">
        <div class="option_box">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-circle-plus-outline"
            plain
            @click="openAddBox()"
            >添加</el-button
          >
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-circle-close"
            plain
            @click="delDataInfo()"
            :disabled="selectedListData.length < 1 ? true : false"
            >删除</el-button
          >
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-open"
            plain
            @click="setRoleStatus(0, 1)"
            :disabled="selectedListData.length < 1 ? true : false"
            >启用</el-button
          >
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-turn-off"
            plain
            @click="setRoleStatus(0, 0)"
            :disabled="selectedListData.length < 1 ? true : false"
            >禁用</el-button
          >
        </div>
        <div class="search_box">
          <el-input
            placeholder="请输入角色名称"
            size="mini"
            class="textInput"
            v-model.trim="requestData.roleName"
            @keyup.enter.native="searchData()"
            clearable
          ></el-input>
          &nbsp;&nbsp;
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-search"
            @click="searchData()"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="page_table_box">
        <div class="school_table_box">
          <el-table
            :data="responseData.list"
            height="100%"
            class="table_box"
            @selection-change="selectListData"
            :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          >
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  responseData.pageSize * (responseData.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="roleName"
              label="角色名称"
              align="center"
              width="160"
            >
            </el-table-column>
            <el-table-column prop="schoolName" label="所属机构" align="center">
            </el-table-column>
            <el-table-column prop="roleDescription" label="描述" align="center">
            </el-table-column>
            <el-table-column
              prop="roleStatus"
              label="状态"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.roleStatus == 1 ? 'success' : 'danger'"
                  >{{
                    $store.state.select.authorityStatus[scope.row.roleStatus]
                  }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              column-key="index"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <el-link
                  type="primary"
                  @click="
                    $Common.paramPageJump(
                      'roleInfo',
                      scope.row,
                      '/access_authority'
                    )
                  "
                  :underline="false"
                  >访问权限</el-link
                > -->
                <el-link
                  type="primary"
                  @click="accessAuthorityManage(scope.row)"
                  :underline="false"
                  >访问权限</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="editAddBox(scope.row)"
                        :underline="false"
                        >编辑</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="userManage(scope.row)"
                        :underline="false"
                        >成员管理</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="userAddClick(scope.row)"
                        :underline="false"
                        >成员新增</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        v-if="scope.row.roleStatus == 1"
                        @click="setRoleStatus(scope.row.roleId, 0)"
                        :underline="false"
                        >禁用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        v-if="scope.row.roleStatus == 0"
                        @click="setRoleStatus(scope.row.roleId, 1)"
                        :underline="false"
                        >启用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="delDataInfo(scope.row.roleId)"
                        :underline="false"
                        >删除</el-link
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="responseData.pages"
            :page-size="responseData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="responseData.total"
          >
          </el-pagination>
        </div>
      </div>
    <AuthorityAddDialog
      :dialogShow="addBox"
      @close="aClose"
    ></AuthorityAddDialog>
    <AuthorityEditDialog
      :dialogShow="editBox"
      :editInfo="editInfo"
      @close="eClose"
    ></AuthorityEditDialog>
    <UserAddDialog
      :showDialog="uShow"
      :roleId="roleId"
      @close="uClose"
    ></UserAddDialog>
    <UserTableDialog
      :showDialog="tShow"
      :roleId="roleId"
      @close="tClose"
    ></UserTableDialog>
    <AccessAuthorityDialog
    ref="AccessAuthorityDialog"
    
    :roleId="roleId"
    @close="yClose"
    >
    </AccessAuthorityDialog>
  </div>
</template>

<script>
import theNoAuthority from "@/components/theNoAuthority";
import AuthorityManagement from "@/components/AuthorityManagement";
import AuthorityAddDialog from "./components/AuthorityAddDialog.vue";
import AuthorityEditDialog from "./components/AuthorityEditDialog.vue";
import UserAddDialog from "./components/AUserAddDialog.vue";
import UserTableDialog from "./components/AUserTableDialog.vue";
import AccessAuthorityDialog from "./components/AccessAuthorityDialog.vue";
export default {
  name: "",
  components: {
    theNoAuthority,
    AuthorityManagement,
    AuthorityAddDialog,
    AuthorityEditDialog,
    UserAddDialog,
    UserTableDialog,
    AccessAuthorityDialog
  },
  props: {},
  data() {
    return {
      // 有无权限
      authority: true,
      addBox: false,
      editBox: false,
      editInfo: {},

      //权限列表数据
      responseData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        pages: 0, // 总页数
        list: [] // 数据列表
      },

      // 获取权限的请求参数
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        roleName: ""
      },
      selectedListData: [],
      uShow: false,
      roleId: "",
      tShow: false,
      yShow:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchData() {
      this.requestData.pageNum = 1;
      this.getDataList();
    },

    selectListData(data) {
      this.selectedListData = data.map((item, index) => {
        return item.roleId;
      });
    },
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getRoleDataList(this.requestData, true);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
        // console.log(this.responseData.list)
      } else if (res.code == 101) {
        this.responseData.total = 0;
        this.responseData.list = [];
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 更改角色状态
    async setRoleStatus(thisId, category) {
      if (thisId >= 1) {
        var requestData = {
          roleId: [thisId],
          category: category
        };
      } else {
        if (this.selectedListData.length < 1) {
          this.$message({
            type: "warning",
            message: "请先选择您要操作的数据"
          });
          return false;
        }
        var requestData = {
          roleId: this.selectedListData,
          category: category
        };
      }
      let res = await this.$Http.setRoleStatus(requestData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 权限数据翻页
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
    },
    // 删除数据
    delDataInfo(thisId = 0) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (thisId >= 1) {
            var requestData = {
              roleId: [thisId]
            };
          } else {
            if (this.selectedListData.length < 1) {
              this.$message({
                type: "warning",
                message: "请先选择您要删除的数据"
              });
              return false;
            }
            var requestData = {
              roleId: this.selectedListData
            };
          }

          let res = await this.$Http.deleteRoleData(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 新增开启
    openAddBox() {
      this.addBox = true;
    },
    // 编辑开启
    editAddBox(row) {
      console.log(row)
      this.editInfo = row;
      this.editBox = true;
    },
    // 新增关闭
    aClose(type) {
      this.addBox = false;
      if (type) {
        this.getDataList();
      }
    },
    eClose(type) {
      this.editBox = false;
      if (type) {
        this.getDataList();
      }
    },
    userAddClick(info) {
      this.uShow = true;
      this.roleId = info.roleId + "";
    },
    uClose() {
      this.uShow = false;
    },
    userManage(info) {
      this.tShow = true;
      this.roleId = info.roleId + "";
    },
    tClose() {
      this.tShow = false;
    },
    accessAuthorityManage(info){
      this.yShow = true
      this.$refs.AccessAuthorityDialog.init(info.roleId)
      this.roleId = info.roleId + "";
    },
    yClose(){
      this.yShow = false
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped>
@import "/css/base.css";
@import "/css/authority.css";
</style>
